window.casino = window.casino || {};
casino.casinoConstants = casino.casinoConstants || {};

casino.utils = {
    nameToUrl: function (name) {
        var normal = name.split(' ').join('-').toLowerCase();
        normal = normal.split('%60').join('');
        return normal.split('`').join('');
    },
    isIos: function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return true;
        }
        return false;
    },
    makeCancelablePromise: function (promise) {
        var hasCanceled_ = false;

        var wrappedPromise = new Promise((resolve, reject) => {
            promise.then((val) =>
                hasCanceled_ ? reject({
                    isCanceled: true
                }) : resolve(val)
            );
            promise.catch((error) =>
                hasCanceled_ ? reject({
                    isCanceled: true
                }) : reject(error)
            );
        });

        return {
            promise: wrappedPromise,
            cancel() {
                hasCanceled_ = true;
            },
        }
    },
    clearToNumberChars: function (value) {
        var NUMBER_CHARS = "1234567890,.";
        return value.split('').filter((char) => NUMBER_CHARS.indexOf(char) !== -1).join('');
    },
    numberToKune: function (number) {
        return this.numberToLocaleString(number).replace("HRK", "kn");
    },
    numberToEuro: function (number, removeCurrency) {
        if (number == null)
            return 'N/A';

        else if (number === '')
            return '€';

        else if (typeof number != 'number')
            number = number.replace(/\./g, '').replace(',', '.');

        var amount = this.numberToLocaleStringEuro(parseFloat(number) / 7.53450).replace("EUR", "€").replace("eur", "€");

        if (removeCurrency)
            return amount.replace(' €', '');
        else
            return amount;

    },
    numberToEuro2: function (number, removeCurrency) {
        if (number == null)
            return 'N/A';

        else if (number === '')
            return '€';

        else if (typeof number != 'number')
            number = number.replace(/\./g, '').replace(',', '.');

        var amount = this.numberToLocaleStringEuro(parseFloat(number)).replace("EUR", "€").replace("eur", "€");

        if (removeCurrency)
            return amount.replace(' €', '');
        else
            return amount;

    },
    numberToHRK: function (number, removeCurrency) {
        if (number == null)
            return 'N/A';

        else if (number === '')
            return 'kn';

        else if (typeof number != 'number')
            number = number.replace(/\./g, '').replace(',', '.');

        var amount = this.numberToLocaleString(parseFloat(number) * 7.53450).replace("HRK", "kn").replace("hrk", "kn");

        if (removeCurrency)
            return amount.replace(' kn', '');
        else
            return amount;

    },
    numberToString: function (number) {
        return this.formatCurrency(number).replace("HRK", "").replace("kn", "").trim();
        //return this.numberToLocaleString(number).replace("HRK", "").replace("kn", "").trim();
    },

    formatCurrency: function (val) {

        if (val == null)
            return 'N/A';

        var currencyFormat;

        val = (Math.round(val * 100) / 100).toFixed(2);

        currencyFormat = '0,00 kn';
        val = val.replace('.', ',');
        val = currencyFormat.replace('0,00', val);

        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return val;
    },
    numberToLocaleString: function (number) {
        if (number == null)
            return 'N/A';

        if (typeof Intl == 'object' && typeof Intl.NumberFormat == 'function') {
            return number.toLocaleString("hr-HR", {
                style: 'currency',
                currency: 'HRK'
            });
        } else {
            return (+number).toFixed(2).toString().replace('.', ',') + ' HRK';
        }
    },
    numberToLocaleStringEuro: function (number) {
        if (number == null)
            return 'N/A';

        if (typeof Intl == 'object' && typeof Intl.NumberFormat == 'function') {
            return number.toLocaleString("hr-HR", {
                style: 'currency',
                currency: 'EUR'
            });
        } else {
            return (+number).toFixed(2).toString().replace('.', ',') + ' €';
        }
    },

    switchKnToEur(amount, returnNumber) {
        if (amount == '' || amount == undefined)
            return '';
        else if (localStorage.getItem('activeCurrency') == 'eur') {
            var amount = this.numberToEuro(amount, true);
            return returnNumber ? parseFloat(amount.toFixed(2)) : amount;
        }
        else
            return returnNumber ? parseFloat(amount.toFixed(2)) : this.numberToLocaleString(amount).replace('kn', '').trim();
    },

    switchEurToKn(amount, returnNumber) {
        if (amount === null || amount === undefined || isNaN(amount))
            return '';
        else if (localStorage.getItem('activeCurrency') == 'kn') {
            var amount = this.numberToHRK(amount, true);
            return returnNumber ? parseFloat(amount.toFixed(2)) : amount;
        }
        else
            return returnNumber ? parseFloat(amount.toFixed(2)) : this.numberToLocaleString(amount).replace('kn', '').trim();
    },

    switchCurrencyKnToEur() {
        return localStorage.getItem('activeCurrency') == 'eur' ? '€' : 'kn';
    },

    stringToNumber: function (string) {
        if (!string)
            return null;
        return Number(string.replace('.', '').replace(',', '.'));
    },
    stringToDate: function (string) {
        if (!string)
            return null;
        return new Date(string.split(".")[2], (Number(string.split(".")[1]) - 1).toString(), string.split(".")[0])
    },
    pxToNumber: function (string) {
        return Number(string.replace('px', ''));
    },
    dateToTimeString: function (date) {
        return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
    },
    dateToTimeString2: function (date) {
        return ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2);
    },
    dateToShortDateString: function (date) {
        return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2);
    },
    dateToDateString: function (date) {
        return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear().toString().slice(-2);
    },
    dateToFullDateString: function (date) {
        return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear().toString() + '.';
    },
    dateToFullDateTimeString: function (date) {
        return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear().toString() + '. ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
    },
    dateToDateTimeString: function (date) {
        return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
    },
    dateToIso: function (date1) {
        if (!date1)
            return null;

        let date = new Date(date1)

        var pad = function (number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate());
    },
    scroolTopAnimation: function (top) {
        var start = window.pageYOffset;
        top = top + start;
        var diff = (top - start) / 14;

        if (diff > 0) {
            window.scrollTo(0, start);

            // var timerID = setInterval(function () {
            //     var ostalo = top - start;
            //     var diffToGo = ostalo > diff ? diff : ostalo;
            //     start += diffToGo;
            //     window.scrollTo(0, start);

            //     if (start >= top)
            //         clearInterval(timerID);
            // }, 14);
        } else {

            top = top - 23;
            window.scrollTo(0, start);
            // var timerID = setInterval(function () {
            //     var ostalo = start - top
            //     var diffToGo = ostalo > diff ? diff : ostalo;
            //     start += diffToGo;
            //     window.scrollTo(0, start);

            //     if (start <= top)
            //         clearInterval(timerID);
            // }, 14);
        }

    },
    capitalizeFirstLetter: function (string) {
        if (!string)
            return string;
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    selectText: function (element) {
        setTimeout(() => {
            element.select();
            element.setSelectionRange(0, 9999);
        }, 10);
    },
    parseQuery: function (search) {
        search = search.split('&amp;').join('&');
        var args = search.substring(1).split('&');
        var argsParsed = {};
        var i, arg, kvp, key, value;
        for (i = 0; i < args.length; i++) {
            arg = args[i];
            if (-1 === arg.indexOf('=')) {
                argsParsed[decodeURIComponent(arg).trim()] = true;
            } else {
                kvp = arg.split('=');
                key = decodeURIComponent(kvp[0]).trim();
                value = decodeURIComponent(kvp[1]).trim();
                argsParsed[key] = value;
            }
        }
        return argsParsed;
    },
    getKeyByValue: function (object, value) {
        return Object.keys(object).find(key => object[key] === value);
    },
    lazyImages: function () {
        let lazyImageObserver = null;

        const mountEventLazyLoadImages = function () {
            if (lazyImageObserver)
                lazyImageObserver.disconnect();


            lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        if (lazyImage.dataset.src) lazyImage.src = lazyImage.dataset.src;
                        if (lazyImage.dataset.srcset) lazyImage.srcset = lazyImage.dataset.srcset;
                        lazyImage.classList.remove("lazy");
                        lazyImageObserver.unobserve(lazyImage);


                        //frosmo - gtm gameImpressions event
                        if (lazyImage.dataset.lazyid) {
                            var game = casino.casinoConstants.games.find(it => it.s == lazyImage.dataset.lazyid);

                            if (game) {

                                var imgsrc = casino.config.gameImagesUrl + casino.casinoConstants.brands[game.bID].nameNormalizirano + "/" + casino.utils.normalizeString(game.n);
                                var webP = casino.config.canIUseWebP ? '.webp' : '.jpeg';
                                var imgBig = imgsrc + webP;

                                var kategorijeArray = [];

                                Object.keys(game.kt).forEach(key => {
                                    var filterKategorija = casino.casinoConstants.categories.find(x => x.id == key);
                                    if (filterKategorija)
                                        kategorijeArray.push(filterKategorija.name);
                                });


                                casino.utils.createGoogleTagManagerEvent({
                                    'event': 'gameImpressions',
                                    'products': [{
                                        'gameId': game.id,
                                        'name': game.n,
                                        'category': kategorijeArray ? kategorijeArray.join() : '',
                                        'vendor': casino.casinoConstants.brands[game.bID],
                                        'image': imgBig,
                                        'launchUrl': `https://mcasino.supersport.hr/game/${casino.casinoConstants.brands[game.bID].nameNormalizirano}/${casino.utils.normalizeString(game.n)}`,
                                        'maintenance': game.p && game.p.indexOf("o") != -1 ? true : false,
                                        'new': game.p && game.p.indexOf("n") != -1 ? true : false,
                                        'exclusive': game.p && game.p.indexOf("ex") != -1 ? true : false,
                                    }]
                                });
                            }
                        }
                    }
                });
            }, {
                threshold: 0,
                rootMargin: '70%'
            });


            let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
            let lazyImageDivs = [].slice.call(document.querySelectorAll("div.lazy"));

            lazyImages.forEach(function (lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });

            lazyImageDivs.forEach(function (lazyDiv) {
                lazyImageObserver.observe(lazyDiv);
            });


        }

        return {
            mountEventLazyLoadImages
        }

    }(),
    generateRandomNumbers(seed, count) {

        var mathSeed = function (s) {
            var mask = 0xffffffff;
            var m_w = (123456789 + s) & mask;
            var m_z = (987654321 - s) & mask;

            return function () {
                m_z = (36969 * (m_z & 65535) + (m_z >>> 16)) & mask;
                m_w = (18000 * (m_w & 65535) + (m_w >>> 16)) & mask;

                var result = ((m_z << 16) + (m_w & 65535)) >>> 0;
                result /= 4294967296;
                return result;
            }
        }
        var myRandomFunction = mathSeed(seed);
        var result = [];
        for (let i = 0; i < count; i++)
            result.push(myRandomFunction());

        return result;
    },
    generateTodayRandomNumber(count) {
        var today = new Date();
        var tt = new Date(today.getFullYear(), today.getMonth(), today.getDate()) - new Date(2020, 1, 1);
        return this.generateRandomNumbers(tt, count);

    },
    dateToUTCShortDateString: function (date) {
        return date.getUTCFullYear() + '-' + ('0' + (date.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (date.getUTCDate())).slice(-2);
    },
    addDays: function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    },
    getGameBackUrl: function (lastGameId, selectedTab = "", from = "", urlParam = "") {
        const isSuperAvantura = window.location.href.includes("super-avantura");

        var url = window.location.href.split('?')[0];
        url = url.split('/game/')[0];
        if (!isSuperAvantura && !url.endsWith("/"))
            url += "/";

        if (isSuperAvantura && urlParam) {
            url += `?sifraavanture=${urlParam}`;
        }

        url += encodeURIComponent(casino.repos.base.serializeGetParams({
            lasttab: selectedTab,
            lastgame: lastGameId,
            lastFrom: from,
        }));

        return url;
    },
    
    getBaseUrl: function () {
        return (document.getElementsByTagName('base')[0] || {}).href;
    },
    setLocalStorageWithExpiry: function (key, value, ttl) {
        const now = new Date()

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
    },
    getLocalStorageWithExpiry: function (key) {
        const itemStr = localStorage.getItem(key)

        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }

        const item = JSON.parse(itemStr)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    },
    canIUseWebP: function () {
        var elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }

        // very old browser like IE 8, canvas not supported
        return false;
    },
    createGoogleTagManagerEvent: function (eventObject) {
        if (window.dataLayer && this.getCookie('analytic') == "1") {
            eventObject.url = window.location.href;
            window.dataLayer.push(eventObject);
        }

    },

    getOperatingSystem: function () {
        var OSName = "Unknown";
        if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) OSName = "Windows 10";
        if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1) OSName = "Windows 8.1";
        if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName = "Windows 8";
        if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName = "Windows 7";
        if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName = "Windows Vista";
        if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName = "Windows XP";
        if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName = "Windows 2000";
        if (window.navigator.userAgent.indexOf("Mac") != -1) OSName = "Mac/iOS";
        if (window.navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";
        if (window.navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
        return OSName;
    },
    arrayMove(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
    },
    getURLParameter: function (sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    },
    getUrlParameters: function () {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    },
    createPageGoogleTagManagerEvent(pageName, pageType, product, user) {

        var casinoRaspolozivo = sportRaspolozivo = ukupnoRaspolozivo = 0;
        if (user) {
            casinoRaspolozivo = user.casinoRaspolozivo;
            sportRaspolozivo = user.sportRaspolozivo;
            ukupnoRaspolozivo = user.ukupnoRaspolozivo;
        }

        setTimeout(() => {
            this.createGoogleTagManagerEvent({
                'event': 'page',
                'page_name': pageName,
                'page_type': pageType,
                'product': product,
                'a_channel': 'direct',
                'current_balance': ukupnoRaspolozivo,
                'current_balance_sport': sportRaspolozivo,
                'current_balance_casino': casinoRaspolozivo,
                'custom_title': document.title,
                'custom_category': document.title,
                'new_url': window.location.href
            });

            //GA360
            this.createGoogleTagManagerEvent({
                'event': 'pageView',
                'page.name': pageName,
                'page.url': window.location.href,
                'page.referrer': document.referrer
            })
        }, 0);
    },
    createClickGoogleTagManagerEvent(tagName, tagType, product, user) {

        var casinoRaspolozivo = sportRaspolozivo = ukupnoRaspolozivo = 0;
        if (user) {
            casinoRaspolozivo = user.casinoRaspolozivo;
            sportRaspolozivo = user.sportRaspolozivo;
            ukupnoRaspolozivo = user.ukupnoRaspolozivo;
        }

        this.createGoogleTagManagerEvent({
            'event': 'page_tag_click',
            'tag_name': tagName,
            'tag_type': tagType,
            'product': product,
            'a_channel': 'direct',
            'current_balance': ukupnoRaspolozivo,
            'current_balance_sport': sportRaspolozivo,
            'current_balance_casino': casinoRaspolozivo
        })
    },
    removeAllSpacesFromString: function (string) {
        string = string.split(' ').join('').toLowerCase();
        return string;
    },
    validateEmail: function (email) {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if (email.match(validRegex))
            return true;
        else
            return false;
    },
    getCookie: function (name) {
        return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || null;
    },
    setCookie(name, value, expirationDays, domain) {
        let date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        let cookieDomain = domain ? domain : casino.config.cookieDomena;
        document.cookie = `${name}=${value}; ${expires};domain=${cookieDomain};path=/`;
    },
    deleteCookie: function (name, domain) {
        let cookieDomain = domain ? domain : casino.config.cookieDomena;
        document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${cookieDomain};path=/`;
    },
    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    },
    getRandomGame: function (allGames, zadnjeIgrano, najigranije, category1, category2) {
        let games = [];
        //zadnje igrane
        if (zadnjeIgrano) {
            zadnjeIgrano.map(x => {
                var igra = allGames.filter(y => y.sifra == x)[0];
                if (igra) games.push(igra);
            });
        }

        //najcesce igrane
        if (najigranije) {
            najigranije.map(x => {
                var igra = allGames.filter(y => y.sifra == x)[0];
                if (igra) games.push(igra);
            });
        }

        if (zadnjeIgrano == null) {
            if (category1) {
                allGames.filter(x => Object.keys(x.kt).indexOf(category1) != -1).map(x => games.push(x));
            }
            if (category2) {
                allGames.filter(x => Object.keys(x.kt).indexOf(category2) != -1).map(x => games.push(x));
            }
        } else {
            if (category1) {
                allGames.filter(x => Object.keys(x.kt).indexOf(category1) != -1).slice(0, 3).map(x => games.push(x));
            }
            if (category2) {
                allGames.filter(x => Object.keys(x.kt).indexOf(category2) != -1).slice(0, 5).map(x => games.push(x));
            }
        }

        //only unique games
        let uniqueGames = [...new Map(games.map(v => [v.id, v])).values()];

        if (!uniqueGames || uniqueGames.length == 0) return null;

        //shuffle
        for (let i = uniqueGames.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [uniqueGames[i], uniqueGames[j]] = [uniqueGames[j], uniqueGames[i]];
        }

        return uniqueGames[0];
    },
    restartGif: function (ImageSelector) {
        var imgSrc = document.querySelector(ImageSelector).src;
        document.querySelector(ImageSelector).src = imgSrc;
    },
    loadGTMScript: function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', casino.config.googleTagManagerID);

        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-PBQRF826');
    },
    removeGTMScript: function () {

        var gtmScript = document.querySelector('script[src="https://www.googletagmanager.com/gtm.js?id=' + casino.config.googleTagManagerID + '"]');
        if (gtmScript)
            gtmScript.parentNode.removeChild(gtmScript);

        var gtmScript2 = document.querySelector('script[src="https://www.googletagmanager.com/gtm.js?id=GTM-PBQRF826"]');
        if (gtmScript2)
            gtmScript2.parentNode.removeChild(gtmScript2);

        casino.utils.deleteGoogleAnalyticsCookies();
        casino.utils.deleteCookie('IDE');

    },
    //loadFrosmoScript() {
    //    let scripts = [
    //        'https://d2wzl9lnvjz3bh.cloudfront.net/frosmo.easy.js',
    //        'https://d2wzl9lnvjz3bh.cloudfront.net/sites/supersport_hr.js'
    //    ];

    //    scripts.forEach(function (url) {
    //        let script = document.createElement('script');
    //        script.src = url;
    //        script.async = false;
    //        document.body.appendChild(script);
    //    })

    //},
    //loadCrazyEggSctipt() {
    //    const script = document.createElement("script");
    //    script.src = "//script.crazyegg.com/pages/scripts/0075/9264.js";
    //    script.async = true;
    //    document.body.appendChild(script);
    //},
    loadMSClaritySctipt() {
        (function (c, l, a, r, i, t, y) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
            t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "upgpulld74");
    },

    generateMinuteTimestamp(minutes) {
        return Math.floor(Date.now() / (60000 * (!minutes || minutes <= 0 ? 1 : minutes)));
    },
    removeSpecialCharacters: function (string) {
        if (string != null) {
            string = string.split(' Mobile').join('');
            string = string.split(' ').join('-').toLowerCase();
            string = string.split('%60').join('');
            string = string.split('&').join('and');
            string = string.split('.').join('-');
            string = string.split(':').join('-');
            string = string.split('`').join('');
            string = string.split('’').join('');
            string = string.split("'").join("");
            string = string.split('™').join('-tm');
            string = string.split('#').join('');
            string = string.split('+').join('-');
            string = string.split('*').join('');
            string = string.split('!').join('');
            string = string.split('?').join('');
            string = string.split('/').join('');
            //ciscenje crtica
            string = string.split('--').join('-');
            return string.split('--').join('-');
        }
        return '';
    },
    normalizeString: function (value) {
        if (value) {
            return this.removeSpecialCharacters(value);
        }

        return '';
    },
    numberWithCurrencyFromated: function (number, currency) {

        if (typeof number != 'number') {
            if (!number) {
                return 'NaN'
            }
            number = parseFloat(number.split('.').join('').replace(',', '.')).toFixed(2)
        }
        else {
            number = parseFloat(number).toFixed(2)
        }
        number = String(number).replace('.', ',')
        var result = this.formatThreeDigits(number)
        return result + ' ' + this.currencySymbolFromValutaID(currency)
    },
    formatThreeDigits: function (integerStr) {
        var len = integerStr.length;
        var formatted = "";

        var breakpoint = (len - 1) % 3;

        for (i = 0; i < len; i++) {
            formatted += integerStr.charAt(i);
            if (i % 3 === breakpoint) {
                if (i < len - 4)
                    formatted += ".";
            }
        }
        return formatted;
    },
    currencySymbolFromValutaID: function (valuta) {
        if (valuta == 'EUR' || valuta == 'eur' || valuta == 'euro' || valuta == 2) {
            return '€';
        }
        else if (valuta == 'HRK' || valuta == 'kn' || valuta == 'euro' || valuta == 1) {
            return 'kn';
        }
        else {
            return '€';
        }
    },
    deleteGoogleAnalyticsCookies: function () {
        // brise sve cookie koji pocinju sa _g
        document.cookie.split(';').forEach((cookie) => {
            cookie = cookie.trim()
            if (cookie.startsWith('_g')) {
                casino.utils.deleteCookie(cookie.split('=')[0])
            }
        })
    },
    navigateToUrl: function (path, newTab) {
        if (newTab) {
            window.open(path, "_blank");
        } else {
            window.location.href = path;
        }
    },

    getCasinoTheme: function () {
        let casinoTheme;
        if (casino.config.fromNativeApp) {
            casinoTheme = casino.config.darkMode ? "dark" : "light";
        } else { 
            casinoTheme = localStorage.getItem("darkModeStrategy") || "light";
        }

        let theme;
        if (casinoTheme === "system") {
            theme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light";
        } else {
            theme = casinoTheme;
        }
        return theme;
    },

    getFilterOdabranoName: function (id) {
        switch (parseInt(id)) {
            case 1: return "Moje zad. odigrano";
            case 2: return "Moje najomiljenije";
            case 3: return "Ekskluzivno";
            case 4: return "Najnovije";
            case 5: return "Respin";
            case 6: return "Megaways";
            case 7: return "Bonus Buy";
            case 8: return "Hold and Win";
            case 9: return "Jackpot Cards";
            case 10: return "Bell Link";
            case 11: return "Golden Coins Link";
            case 12: return "Barlink";
            case 13: return "Jackpot Rain";
            case 14: return "Egypt Quest";
            case 15: return "Golden Nights";
            case 16: return "Red Hot Fire Pot";
            case 17: return "Gameart Jackpot";
            case 18: return "Clover Chance";
            default: return id;
        }
    }
};